import { render } from "./CharlaMoney.vue?vue&type=template&id=0fa0afc6&scoped=true"
import script from "./CharlaMoney.vue?vue&type=script&lang=js"
export * from "./CharlaMoney.vue?vue&type=script&lang=js"

import "./CharlaMoney.vue?vue&type=style&index=0&id=0fa0afc6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa0afc6"]])

export default __exports__